export const buildEndpoint = (
  baseApiPath: string,
  apiVersion: string,
  service: 'reportservice' | 'reportagent',
  path: string,
) => `${baseApiPath}${service}/${apiVersion}${path.startsWith('/') ? '' : '/'}${path}`;

export const API_ENDPOINTS = {
  REPORT_SERVICE: {
    REPORTS: {
      ReportType: '/api/reports/report-types',
      RecentReports: '/api/reports/reports',
      Clients: '/api/reports/clients',
      ReportsByType: '/api/reports/reportsByType',
      States: '/api/reports/states',
      Locations: '/api/reports/locations',
      ApprovalStatus: '/api/reports/{reportId}/update/status',
      CreateReport: '/api/reports/add-report',
      UpdateComments: '/api/reports/{reportId}/comment',
      GetCharts: '/api/reports/chart-data',
      DeleteReport: '/api/reports/{reportId}/delete',
      GetReportSections: '/api/reports/{reportId}/sections',
      AddReportSection: '/api/reports/add/reportsection',
      UpdateReportSections: '/api/reports/update/reportsections',
      DeleteReportSections: '/api/reports/delete/reportsections',
      UpdateValidationRequested: '/api/reports/{reportId}/sections/validation',
      GenerateReportStatus: '/api/reports/{reportId}/status',
      GetReworkSections: '/api/reports/sections/rework',
      DeleteComment: '/api/reports/{reportId}/comment/delete',
    },
    FILES: {
      GetProjectFiles: '/api/files/search',
      ReportDownload: '/api/files/download?format=blob',
    },
    PERMISSIONS: {
      UserPermissions: '/api/permissions/users/{email}',
    },
    REVIEWER: {
      GetReviewers: '/api/reviewers',
      AddReviewer: '/api/reviewers',
    },
  },
  AGENT_SERVICE: {
    StartOrchestration: '/api/reports/{reportId}/orchestration',
  },
} as const;
